import { Form, Container, Table } from 'react-bootstrap'
import { Request } from '@group-devs/yfp7-global-modules'
import { useState, useEffect } from 'react'

const request = new Request(process.env.apiDomain)
//const month = ["January", "February ", "March ", "April ", "May ", "June ", "July ", "August ", "September ", "October ", "November ", "December "]

export default function MonthlyStats(props){

    let contactAccount = props.contactAccount

    const [contactId, setContactId] = useState(null);

    const [year, setYear] = useState(new Date().getFullYear())

    
    const contact_id = contactId;

    useEffect(() => {

        if(typeof contactAccount != 'undefined'){

            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    // Get monthly statistics
    const { data: monthly} = request.stats.monthlyStats(contact_id,year);
    
    const monthlyStatistics = monthly ? JSON.parse(monthly.stats) : []

    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    
    const currentYear = new Date().getFullYear(); //Current Year
    const years = range(currentYear, currentYear - 2, -1); 

    const onChangeHandler = (e) =>{
        setYear(parseInt(e.target.value))
    }

    return(
        <Container className="pb-5 mb-5">
            

            <Form className="form-inline">
                <Form.Group controlId="year">
                <h4 className="my-5 font-weight-bold">Monthly Overview:&nbsp;</h4> 

                <Form.Control
                  as="select"
                  name="year"
                  onChange={(e) => onChangeHandler(e)}
                >
                {
                    years.map((yr, idx) => (
                        <option value={yr}>{yr}</option>
                    ))
                }
                </Form.Control>
              </Form.Group>

            </Form>

            

            <Table striped  responsive="sm">
                <thead>
                <tr>
                    <th>Month</th>
                    <th>Points Earned</th>
                    <th>Badges & Rewards</th>
                    <th>Events Attended</th>
                    <th>Reviews Given</th>
                </tr>
                </thead>
                <tbody>
                    { 

                        monthly ? 
                            Object.keys(monthlyStatistics).map((data, index) => (
                                <tr key={index}>
                                    <td>{monthlyStatistics[data].month}</td>
                                    <td>{monthlyStatistics[data].points}</td>
                                    <td>{monthlyStatistics[data].badges}</td>
                                    <td>{monthlyStatistics[data].events_attended}</td>
                                    <td>{monthlyStatistics[data].reviews_given}</td>
                                </tr>
                            ))

                        : ''
                    }
                </tbody>
            </Table>
            <style jsx global>
                {  `
                    table td:not(:nth-of-type(1)),  table th:not(:nth-of-type(1)){
                        text-align: center;
                    }
                    table th{
                        background-color:#43a649;
                        color:#fff;
                        border:0;
                    }
                    .table td, .table th{
                        border: 0!important;
                    }
                    .table-striped tbody tr:nth-of-type(odd) {
                        background-color: transparent;
                    }
                    .table-striped tbody tr:nth-of-type(even) {
                        background-color: rgba(0,0,0,.05);
                    }
                `}
            </style>
        </Container>
    )
}